import { fetchEntryRequests } from 'modules/teams/store/entry-requests/actions';
import {
  selectEntryRequests,
  selectEntryRequestsLoaded,
  selectEntryRequestsLoading,
} from 'modules/teams/store/entry-requests/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';

export const useEntryRequests = (teamId: number) => {
  const dispatch = useDispatch<AppDispatch>();
  const entryRequests = useSelector(selectEntryRequests);
  const isLoading = useSelector(selectEntryRequestsLoading);
  const isLoaded = useSelector(selectEntryRequestsLoaded);

  useEffect(() => {
    if (isLoaded) {
      return;
    }
    dispatch(fetchEntryRequests(teamId));
  }, [dispatch, teamId, isLoaded]);

  return { entryRequests, isLoading, isLoaded };
};
